import angular from 'angular';
import booksMenu from '../../menu/Menu';

export default angular
  .module('studentReport', [booksMenu])
  .controller('studentReportController', studentReportController)
  .name;
  
  
/* @ngInject */ function studentReportController($scope, BooksSvc, BusyScreen, SERVER, $q, Session) {
  /** Selected Student Model. */
  var mStudent = null;

  /** Flag used when looking up student by ID. */
  var mInLookup = false;

  $scope.data = { selections: [] };
  $scope.reportPage = Session.getSessionURL('/StudentReport.aspx');

  /*---------------------*/
  /* Sets default values */
  /*---------------------*/
  $scope.req = { reportFormat: 'PDF' };

  /*-------------------------------*/
  /* Array of reporting selections */
  /*-------------------------------*/
  $scope.reportTypes = [
    { text: 'Records', prop: 'includeRecords' },
    { text: 'Fees', prop: 'includeFees' },
    { text: 'Equipment', prop: 'includeEquipment' },
    { text: 'Textbooks', prop: 'includeTextbooks' },
    { text: 'Fines', prop: 'includeFines' },
    { text: 'Unpaid Items', prop: 'includeUnpaid' },
    { text: 'Open Orders', prop: 'includeOpenOrders' },
    { text: 'Activity', prop: 'includeActivity' },
    { text: 'Clubs', prop: 'includeClubs' }
  ];

  /*--------------------------------------*/
  /* Works with the csm Validator to make */
  /* sure there is a student selected     */
  /*--------------------------------------*/
  $scope.valOption = {};
  $scope.validateInput = function () {
    /*-------------------------------------------------------*/
    /* If the student lookup by ID has not completed, return */
    /* false so the lookup completes and populates the input */
    /* with the student name before submitting the report.   */
    /*-------------------------------------------------------*/
    if (mInLookup) return false;

    /*------------------------------------------------*/
    /* Sets the reporting properties based on what is */
    /* selected in the dropdown from the reportTypes  */
    /* array when the submit button is clicked.       */
    /*------------------------------------------------*/
    $scope.reportTypes.forEach(function (rt) {
      $scope.req[rt.prop] = $scope.data.selections.indexOf(rt.prop) > -1;
    });

    /*-------------------------------------------------------*/
    /* Digest is here to update the model before submission. */
    /*-------------------------------------------------------*/
    $scope.$digest();
    return $scope.valOption.validate();
  };

  /*****************************************************************************
   * getStudents */
  /**
   * Gets the list of students that have a name that starts with the entered text
   * typeahead.
   *
   * @param  text   Text entered in the input.
   * @return        Promise that resolves with the array of student EntityListItems
   *****************************************************************************/
  $scope.getStudents = function (text) {
    if (text)
      return BooksSvc.findEntities(
        text,
        SERVER.BooksDBConstants.ET_STUDENT
      ).then(function (resp) {
        return resp.data;
      });
    else return null;
  };

  /*****************************************************************************
   * students */
  /**
   * Getter/Setter for the selected student. This will update the $scope.req.id
   * for the provided student. If the pass student is a string, it is assumed to
   * be a barcode and a query will be made to look up the corresponding student.
   *
   * @param  student EntityListItem/String to set
   * @return         Current value of mStudent
   *****************************************************************************/
  $scope.student = function (student) {
    /*--------*/
    /* Getter */
    /*--------*/
    if (!arguments.length) return mStudent;

    /*--------*/
    /* Setter */
    /*--------*/
    mStudent = student;

    if (mStudent && angular.isString(mStudent)) {
      mInLookup = true;
      BooksSvc.getEntityByStudentID(mStudent, true).then(function (resp) {
        mInLookup = false;
        $scope.student(resp.data ? resp.data.entity : null);
      });
    }
    $scope.req.id =
      mStudent && angular.isObject(mStudent) ? mStudent.id : NaN;
  };

  /*-------------------------------------------------*/
  /* Defaults the report dropdown to check all types */
  /*-------------------------------------------------*/
  $scope.reportTypes.forEach(function (rt) {
    $scope.data.selections.push(rt.prop);
  });

  /*-------------------*/
  /* Load initial data */
  /*-------------------*/
  BooksSvc.getOrganization().then(function (resp) {
    $scope.org = resp.data;
    BusyScreen.setBusy(false);
  });
}